import type {
	BoundActions,
	HookFunction,
	OverrideContainerComponent,
	StoreActionApi,
} from 'react-sweet-state';
import { createStore, createHook, createContainer } from 'react-sweet-state';

const Store = createStore({
	initialState: {
		isContentReady: false,
		contentLoading: {},
	},
	actions: {
		onContentRendered:
			(): (({
				setState,
			}: StoreActionApi<{
				isContentReady: boolean;
				contentLoading: {};
			}>) => void) =>
			({ setState }) => {
				setState({
					isContentReady: true,
				});
			},

		addContentToBeLoaded:
			(
				content: any,
				value: any,
			): (({
				setState,
				getState,
			}: StoreActionApi<{
				isContentReady: boolean;
				contentLoading: {};
			}>) => void) =>
			({ setState, getState }) => {
				const newContentLoading: any = getState().contentLoading;
				newContentLoading[content] = value;
				setState({
					contentLoading: newContentLoading,
				});
			},
		removeContentFromLoading:
			(
				content: any,
			): (({
				setState,
				getState,
			}: StoreActionApi<{
				isContentReady: boolean;
				contentLoading: {};
			}>) => void) =>
			({ setState, getState }) => {
				const existingContentLoading: any = getState().contentLoading;
				existingContentLoading[content] && delete existingContentLoading[content];

				setState({
					contentLoading: existingContentLoading,
				});
			},
	},
	name: 'isContentReady',
});

export const ContentStateContainer: OverrideContainerComponent<unknown> = createContainer(Store);
export const useContentState: HookFunction<
	{
		isContentReady: boolean;
		contentLoading: {};
	},
	BoundActions<
		{
			isContentReady: boolean;
			contentLoading: {};
		},
		{
			onContentRendered: () => ({
				setState,
			}: StoreActionApi<{
				isContentReady: boolean;
				contentLoading: {};
			}>) => void;
			addContentToBeLoaded: (
				content: any,
				value: any,
			) => ({
				setState,
				getState,
			}: StoreActionApi<{
				isContentReady: boolean;
				contentLoading: {};
			}>) => void;
			removeContentFromLoading: (content: any) => ({
				setState,
				getState,
			}: StoreActionApi<{
				isContentReady: boolean;
				contentLoading: {};
			}>) => void;
		}
	>,
	void
> = createHook(Store);
